import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { AdminVoicesRoute } from "./-VoicesPage"

const searchSchema = z.object({ id: z.string().optional() }).partial()

export const Route = createFileRoute("/admin/voices" as any)({
  validateSearch: searchSchema,
  component: AdminVoicesRoute,
})
